const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-container">
          <a href="/">
            <div className="logo-container">
              <div className="logo-image"><img src="/logo.svg" alt="crons" /></div>
            </div>
          </a>
          <h1 className="bg-gradient">Super Easy Cron Expression Generator</h1>
        </div>{/* header-container */}
      </div>{/* container */}
    </header>
  )
}

export default Header;